// export const ACCEPT_ACCOUNT = ["eddtest", "teth05", "adnan02", "rubel02"] as string[];
export const ACCEPT_ACCOUNT = [] as string[];

export const canAccessTransfer = (username?: string) => {
  if (!username) return false;

  // Nếu mảng rỗng => tất cả tài khoản đều được vào
  if (ACCEPT_ACCOUNT.length === 0) return true;

  // Nếu có cấu hình account => chỉ những account trong list mới được vào
  return ACCEPT_ACCOUNT.includes(username);
};
